import React, { useEffect, useState } from "react";

import { checkAdminAccess, useAdminUserContext, useNavigate, useParams } from "utils";

import { ErrorBoundary, MainPage, Tabs } from "components";

import { PastPaymentList } from "pages/admin/payments/PastPaymentList";
import { PendingPaymentList } from "pages/admin/payments/PendingPaymentList";
import { ReferralPaymentList } from "pages/admin/payments/ReferralPaymentList";

export const Payments = () => {
  const { section } = useParams();
  const { user } = useAdminUserContext();

  const [currentSection, setCurrentSection] = useState(false);
  const navigate = useNavigate();

  const tabList = [
    {
      name: "Pending payments",
      key: "pending",
      component: <PendingPaymentList user={user} />,
    },
    {
      name: "Past payments",
      key: "past",
      component: <PastPaymentList user={user} />,
    },
    {
      name: "Referral payments",
      key: "referral",
      component: <ReferralPaymentList user={user} />,
    },
  ];

  const getTabItems = () => {
    const tabs = [];
    tabList.forEach((tab) => {
      if (checkAdminAccess(user.role, `payments/${tab.key}`)) {
        tabs.push({
          label: tab.name,
          key: tab.key,
          children: <ErrorBoundary>{tab.component}</ErrorBoundary>,
        });
      } else {
        tabs.push({
          label: tab.name,
          key: tab.key,
          children: <ErrorBoundary>{tab.component}</ErrorBoundary>,
          disabled: true,
        });
      }
    });
    return tabs;
  };

  useEffect(() => {
    setCurrentSection(section);
  }, [section]);

  return (
    <MainPage pageName={"admin"}>
      <Tabs activeKey={currentSection} size="small" onChange={(v) => navigate({ pathname: `/payments/${v}` }, { replace: true })} items={getTabItems()} />
    </MainPage>
  );
};
